import { useEffect, useMemo, useState } from "react";
import { supabase } from "../../supabaseClient";


export default function useEventLayout(eventKey, fallbackConfig) {
  const [state, setState] = useState({ items: null, loading: true });

  useEffect(() => {
    if (!eventKey) return;
    let cancelled = false;
    setState({ items: null, loading: true });

    const load = async () => {
      const { data, error } = await supabase
        .from("layouts_published").select("items").eq("event_key", eventKey).maybeSingle();
      if (cancelled) return;
      if (error) console.error("useEventLayout:", error);
      const ok = !error && Array.isArray(data?.items) && data.items.length > 0;
      setState({ items: ok ? data.items : null, loading: false });
    };
    load();

    const ch = supabase.channel(`layout-published-${eventKey}`)
      .on("postgres_changes",
        { event: "*", schema: "public", table: "layouts_published", filter: `event_key=eq.${eventKey}` },
        load)
      .subscribe();

    return () => { cancelled = true; supabase.removeChannel(ch); };
  }, [eventKey]);

  const config = useMemo(
    () => (state.items ? state.items : fallbackConfig),
    [state.items, fallbackConfig]
  );

  return { config, loading: state.loading, source: state.loading ? "loading" : state.items ? "database" : "file" };
}